import request from "@/utils/request.js";
//获取学习资料列表
export const getLearningMaterialList = (data) => {
	return request({
		method: "post",
		url: "api/LearningMaterials/GetLearningMaterialList",
		data
	});
};

//获取专家列表
export const getIndustryExpertList = (data) => {
	return request({
		method: "post",
		url: "api/IndustryExpert/GetIndustryExpertList",
		data
	});
};

//获取相关学习资料列表
export const getRelaLearningMaterials = (data) => {
	return request({
		method: "post",
		url: "api/LearningMaterials/GetRelaLearningMaterials",
		data
	});
};